import './App.css';
import { useEffect, useState } from 'react';

const apps = [
  {
    slug: '12Pack',
    name: '12Pack',
    tagline: 'Say goodbye to forgotten socks and last-minute stress — your luggage packing app is now live!',
    features: [
       '✈️ Create travels to attach your luggage lists to',
      '📋 Build reusable luggage templates so you never start from scratch',
      '🗂 Sort luggage by category for a clear, organized view',
      '👥 Add participants and assign luggage items to one or more people',
      '✅ Check off items as you pack, so nothing is left behind',
    ],
    story: 'Pack smarter, so nothing (and no one) is left behind 😉',
  },
];

const parseRoute = () => {
  const hash = window.location.hash || '#/';
  const path = hash.replace('#', '');
  const parts = path.split('/').filter(Boolean);

  if (parts[0] === 'app' && parts[1]) {
    return { page: 'app', slug: parts[1] };
  }
  if (parts[0] === 'apps') {
    return { page: 'apps' };
  }
  if (parts[0] === 'contact') {
    return { page: 'contact' };
  }
  return { page: 'home' };
};

function App() {
  const [route, setRoute] = useState(parseRoute());
  const activeApp = apps.find((app) => app.slug === route.slug);

  useEffect(() => {
    const handleHashChange = () => setRoute(parseRoute());
    window.addEventListener('hashchange', handleHashChange);
    if (!window.location.hash) {
      window.location.hash = '#/';
    }
    return () => window.removeEventListener('hashchange', handleHashChange);
  }, []);

  return (
    <div className="site">
      <nav className="site-nav">
        <a className="logo" href="#/">
          <img
            className="logo-icon"
            src={`${process.env.PUBLIC_URL}/LeanFactorLogo.png`}
            alt="LeanFactor logo"
          />
          <span>Lean Factor</span>
        </a>
        <div className="nav-links">
          <a className={route.page === 'home' ? 'active' : ''} href="#/">
            Studio
          </a>
          <a className={route.page === 'apps' ? 'active' : ''} href="#/apps">
            Apps
          </a>
          <a className={route.page === 'contact' ? 'active' : ''} href="#/contact">
            Contact
          </a>
        </div>
      </nav>

      <main>
        {route.page === 'home' && (
          <>
            <section className="hero">
              <div className="hero-content reveal" style={{ '--delay': '0ms' }}>
                <span className="eyebrow">Two activity streams, one team</span>
                <h1>Lean Factor delivers project leadership and app products under distinct brands.</h1>
                <p className="lede">
                  We support organizations with structured project management through Lean Factor,
                  while JellyBeanStudios builds practical apps that make everyday work and life simpler.
                </p>
                <div className="hero-actions">
                  <a className="btn primary" href="#/contact">
                    Talk with us
                  </a>
                </div>
              </div>
              <div className="business-grid">
                <article className="hero-card business-card reveal" style={{ '--delay': '140ms' }}>
                  <div className="hero-card-top">
                    <span>Project management</span>
                    <span className="status">Lean Factor</span>
                  </div>
                  <div className="business-brand">
                    <img
                      className="business-logo leanfactor-logo"
                      src={`${process.env.PUBLIC_URL}/LeanFactorLogo.png`}
                      alt="Lean Factor logo"
                    />
                    <h2 className="app-title leanfactor-title">Lean Factor</h2>
                  </div>
                  <p>
                    Lean Factor helps teams structure delivery, align stakeholders, and keep complex
                    initiatives moving with clarity and discipline.
                  </p>
                  <ul className="business-list">
                    <li>Project coordination and planning</li>
                    <li>Stakeholder alignment and follow-up</li>
                    <li>Execution support from kickoff to delivery</li>
                  </ul>
                  <div className="hero-card-actions">
                    <a className="btn ghost" href="#/contact">
                      Discuss a project
                    </a>
                  </div>
                </article>

                <article className="hero-card business-card reveal" style={{ '--delay': '260ms' }}>
                  <div className="hero-card-top">
                    <span>App development</span>
                    <span className="status">JellyBeanStudios</span>
                  </div>
                  <div className="business-brand">
                    <a
                      className="business-logo-link"
                      href="#/"
                      aria-label="JellyBeanStudios home"
                    >
                      <img
                        className="business-logo"
                        src={`${process.env.PUBLIC_URL}/JellyBeanStudiosLogo.png`}
                        alt="JellyBeanStudios logo"
                      />
                    </a>
                    <h2 className="app-title">JellyBeanStudios</h2>
                  </div>
                  <p>
                    JellyBeanStudios designs and ships focused digital products, with simple user
                    experiences and clear value from day one.
                  </p>
                  <ul className="business-list">
                    <li>Product design and mobile app development</li>
                    <li>Brand-led consumer app experiences</li>
                    <li>Current release: {apps[0].name}</li>
                  </ul>
                  <div className="hero-card-actions">
                    <a className="btn primary" href={`#/app/${apps[0].slug}`}>
                      View {apps[0].name}
                    </a>
                    <a className="btn ghost" href="#/apps">
                      Browse all apps
                    </a>
                  </div>
                </article>
              </div>
            </section>

            <section className="section">
             
            </section>
          </>
        )}
 
        {route.page === 'apps' && (
          <section className="section">
            <div className="section-head">
              <h2>Apps</h2>
              <p>Our current lineup is small, crafted, and full of momentum.</p>
            </div>
            <div className="app-grid">
              {apps.map((app, index) => (
                <a
                  className="app-card reveal"
                  style={{ '--delay': `${index * 140}ms` }}
                  href={`#/app/${app.slug}`}
                  key={app.slug}
                >
                  <div className="app-card-top">
                    <span className="pill">App</span>
                    <span className="status">{app.status}</span>
                  </div>
                  <div className="app-card-title">
                    <img
                      className="app-card-icon"
                      src="/12packlogo_transparent.png"
                      alt="12pack app icon"
                    />
                    <h3>{app.name}</h3>
                  </div>
                  <p>{app.tagline}</p>
                  <span className="app-link">Open details →</span>
                </a>
              ))}
            </div>
          </section>
        )}
      
        {route.page === 'app' && (
          <section className="section app-detail">
            {activeApp ? (
              <>
                <div className="detail-hero reveal" style={{ '--delay': '0ms' }}>
                  <div className="detail-hero-main">
                    <h1 className="detail-title">
                      <img
                        className="detail-icon"
                        src="/12packlogo_transparent.png"
                        alt="12pack app icon"
                      />
                      {activeApp.name}
                    </h1>
                    <p className="lede">{activeApp.tagline}</p>
                    <p className="detail-summary">{activeApp.summary}</p>
                  </div>
                  <div className="detail-hero-side">
                    <div className="detail-download-badges">
                      <a
                        className="download-badge-link"
                        href="https://apps.apple.com/be/app/12pack/id6746409852?l=fr-FR"
                        target="_blank"
                        rel="noreferrer"
                        aria-label="Download on the App Store"
                      >
                        <img
                          className="download-badge"
                          src={`${process.env.PUBLIC_URL}/DownloadBadgeAppStore.svg`}
                          alt="Download on the App Store"
                        />
                      </a>
                      <a
                        className="download-badge-link"
                        href="https://play.google.com/store/apps/details?id=com.jellybean.checkit_flutter&hl=nl"
                        target="_blank"
                        rel="noreferrer"
                        aria-label="Get it on Google Play"
                      >
                        <img
                          className="download-badge"
                          src={`${process.env.PUBLIC_URL}/DownloadBadgeGooglePlay.png`}
                          alt="Get it on Google Play"
                        />
                      </a>
                    </div>
                  </div>
                </div>
                <div className="detail-grid">
                  <div className="detail-card reveal" style={{ '--delay': '120ms' }}>
                    <h3>With 12Pack you will</h3>
                    <p>{activeApp.story}</p>
                  </div>
                  <div className="detail-card reveal" style={{ '--delay': '360ms' }}>
                    <h3>Feature set</h3>
                    <ul>
                      {activeApp.features.map((item) => (
                        <li key={item}>{item}</li>
                      ))}
                    </ul>
                  </div>
                  <div className="detail-card wide-card reveal" style={{ '--delay': '360ms' }}>
                    <h3>App print screens</h3>
                    <div className="screenshot-grid">
                      <img
                        className="screenshot"
                        src={`${process.env.PUBLIC_URL}/Travels%20overview.PNG`}
                        alt="Travels overview screen"
                      />
                      <img
                        className="screenshot"
                        src={`${process.env.PUBLIC_URL}/Travels%20luggages%20overview.PNG`}
                        alt="Travels luggage overview screen"
                      />
                      <img
                        className="screenshot"
                        src={`${process.env.PUBLIC_URL}/Participants%20overview.PNG`}
                        alt="Participants overview screen"
                      />
                      <img
                        className="screenshot"
                        src={`${process.env.PUBLIC_URL}/Templates%20overview.PNG`}
                        alt="Templates overview screen"
                      />
                      <img
                        className="screenshot"
                        src={`${process.env.PUBLIC_URL}/Template%20luggages%20overview.PNG`}
                        alt="Templates luggage overview screen"
                      />
                    </div>
                  </div>
                  <div className="detail-card reveal" style={{ '--delay': '360ms' }}>
                    <h3>Which personal data do we store?</h3>
                    <p>In order to create your account, we store following data:</p>
                    <li>Your first name</li>
                    <li>Your last name</li>
                    <li>Your email address</li>
                    <p>The data is stored in Firebase, a Back-end-as-a-service platform from Google.</p>
                    <p>12Pack uses following Firebase services: Authentication and Databases</p>
                  </div>
                  <div className="detail-card reveal" style={{ '--delay': '360ms' }}>
                    <h3>Suppress your account</h3>
                    <p>To suppress your account, follow the following steps:</p>
                    <li>Log into the app</li>
                    <li>In the bottom navigation, click on Profile</li>
                    <li>On your profile page, click on the red button "Delete account"</li>      
                  </div>
                </div>
                
              </>
            ) : (
              <div className="empty-state">
                <h2>We cannot find that app yet.</h2>
                <p>Head back to the studio overview.</p>
                <a className="btn primary" href="#/apps">
                  Browse apps
                </a>
              </div>
            )}
          </section>
        )}

        {route.page === 'contact' && (
          <section className="section contact">
            <div className="contact-card reveal" style={{ '--delay': '0ms' }}>
              <h1>Get in touch</h1>
              <p className="lede">Choose the brand that matches your question.</p>
              <p>Lean Factor - BE0848.164.832 - Vijfstraten 3, 3140 Keerbergen, Belgium</p>
              <div className="contact-grid">
                <div className="detail-card reveal" style={{ '--delay': '120ms' }}>
                  <div className="business-brand">
                    <img
                      className="business-logo leanfactor-logo"
                      src={`${process.env.PUBLIC_URL}/LeanFactorLogo.png`}
                      alt="Lean Factor logo"
                    />
                    <h2 className="app-title leanfactor-title">Lean Factor</h2>
                  </div>
                  <p className="contact-copy">
                    For project management support, delivery coordination, and anything related to project management.
                  </p>
                  <a className="btn ghost" href="mailto:sylviedebrabanter@leanfactor.eu">
                    sylviedebrabanter@leanfactor.eu
                  </a>
                </div>
                <div className="detail-card reveal" style={{ '--delay': '220ms' }}>
                  <div className="business-brand">
                    <img
                      className="business-logo"
                      src={`${process.env.PUBLIC_URL}/JellyBeanStudiosLogo.png`}
                      alt="JellyBeanStudios logo"
                    />
                    <h2 className="app-title">JellyBeanStudios</h2>
                  </div>
                  <p className="contact-copy">
                    For app development, product ideas, and anything related to the studio's apps.
                  </p>
                  <a className="btn ghost" href="mailto:sylvie.debrabanter@jellybeanstudios.be">
                    sylvie.debrabanter@jellybeanstudios.be
                  </a>
                </div>
              </div>
            </div>
          </section>
        )}
      </main>

      <footer className="site-footer">
        <span>© 2026 JellyBeanStudios @ 2026 Lean Factor. All rights reserved.</span>
        <span>Simple apps, simple life!</span>
      </footer>
    </div>
  );
}

export default App;
